/**
 * Shared "is this timesheet entry a day off?" check.
 *
 * Used by the Timesheet calendar display, the right-panel detail
 * rows, the recompute function in the edit modal, and the payroll
 * math. Keeping it in one place guarantees that the Salary page's
 * late/undertime deductions stay in sync with what the Timesheet
 * page shows to the user.
 *
 * A day is considered "off" (→ no late / no undertime) when:
 *   - the entry's status is "Holiday", OR
 *   - the entry's date falls on a Sunday (local time).
 *
 * Saturday is intentionally NOT treated as a day off because the
 * project's bulk-create logic and existing calendars assume a
 * six-day working week.
 */
export function isTimesheetDayOff(entry) {
  if (!entry) return false;
  if (entry.status === "Holiday") return true;

  // The backend serialises LocalDate as either a string "YYYY-MM-DD"
  // or a [year, month, day] tuple depending on the Jackson config, so
  // we normalise both shapes here.
  let y, mo, d;
  if (typeof entry.date === "string" && /^\d{4}-\d{2}-\d{2}/.test(entry.date)) {
    [y, mo, d] = entry.date.slice(0, 10).split("-").map(Number);
  } else if (Array.isArray(entry.date) && entry.date.length >= 3) {
    [y, mo, d] = entry.date.map(Number);
  } else {
    return false;
  }
  if (!Number.isFinite(y) || !Number.isFinite(mo) || !Number.isFinite(d)) return false;

  // Build the date in UTC so the day-of-week check is unaffected by
  // the browser's timezone (new Date("YYYY-MM-DDT00:00:00") is local
  // and can drift across day boundaries).
  const dt = new Date(Date.UTC(y, mo - 1, d));
  return !isNaN(dt.getTime()) && dt.getUTCDay() === 0;
}
